<template>
    <v-text-field
        v-model="model"
        :append-inner-icon="clearable && model ? 'clear' : ''"
        @click:appendInner.stop="model = null"
        readonly
        :error-messages="errorMessages"
        :rules="rules"
        :hide-details="hideDetails"
        :max-width="maxWidth"
    >
        <v-menu
            :close-on-content-click="false"
            activator="parent"
            transition="scale-transition"
        >
            <v-time-picker
                title=" "
                v-model="model"
                format="24hr"
                elevation="18"
                color="secondary"
                class="rounded"
                :min="min"
                :max="max"
                :disabled="disabled"
                scrollable
                full-width
            ></v-time-picker>
        </v-menu>
    </v-text-field>
</template>
<script setup>
import { VTimePicker } from 'vuetify/labs/VTimePicker'
const {min, max, disabled} = defineProps({
    min: {
        type: String,
        default: '00:00'
    },
    max: {
        type: String,
        default: '23:59'
    },
    maxWidth: {
        type: [Number, String],
        default: '23:59'
    },
    clearable: {
        type: Boolean,
        default: false
    },
    hideDetails: {
            default: false
    },
    errorMessages: {
        default: () => []
    },
    rules: {
        default: () => []
    },
    disabled: {
        type: Boolean
    }
});
const model = defineModel();
</script>
